const cardItems = [
  {
    id: 1,
    title: '国产剧年度盘点',
    desc: '2026年上半年最值得回味的国产电视剧，从古装到都市，每一部都是口碑之作。',
    tag: '盘点',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20collage%20style%20with%20warm%20red%20and%20gold%20gradient%2C%20abstract%20cinematic%20elements%2C%20soft%20atmospheric%20lighting%2C%20editorial%20design%20with%20depth%2C%20horizontal%20layout%2C%20clean%20composition%2C%20no%20text&width=600&height=450&seq=cards-01&orientation=landscape',
  },
  {
    id: 2,
    title: '韩剧推荐：必看清单',
    desc: '精选十部超高评分韩剧，甜蜜浪漫与悬疑烧脑，满足你的所有追剧口味。',
    tag: '推荐',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20themed%20visual%20with%20soft%20romantic%20peach%20and%20coral%20gradient%2C%20dreamy%20bokeh%20effects%2C%20modern%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20horizontal%20layout%2C%20no%20text&width=600&height=450&seq=cards-02&orientation=landscape',
  },
  {
    id: 3,
    title: '暑期档追剧指南',
    desc: '暑假来了！这份追剧指南帮你规划整个假期的观影片单，每天都有新惊喜。',
    tag: '指南',
    img: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20guide%20visual%20with%20vibrant%20warm%20sunset%20gradient%2C%20playful%20abstract%20shapes%2C%20cinematic%20atmosphere%2C%20clean%20editorial%20design%2C%20horizontal%20layout%2C%20bright%20uplifting%20mood%2C%20no%20text&width=600&height=450&seq=cards-03&orientation=landscape',
  },
  {
    id: 4,
    title: '动画电影精选合集',
    desc: '从经典到最新，适合全家一起观看的动画电影大全，欢乐与感动并存。',
    tag: '合集',
    img: 'https://readdy.ai/api/search-image?query=Animation%20movie%20collage%20with%20colorful%20playful%20gradient%20in%20warm%20orange%20and%20pink%20tones%2C%20whimsical%20abstract%20elements%2C%20family%20friendly%20vibe%2C%20editorial%20design%2C%20horizontal%20layout%2C%20no%20text&width=600&height=450&seq=cards-04&orientation=landscape',
  },
  {
    id: 5,
    title: '悬疑剧迷必看片单',
    desc: '烧脑反转不断，那些让人欲罢不能的悬疑佳作，每一部都值得二刷。',
    tag: '片单',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20themed%20visual%20with%20dramatic%20warm%20amber%20and%20dark%20shadow%20contrast%2C%20cinematic%20moody%20atmosphere%2C%20abstract%20geometric%20elements%2C%20editorial%20style%2C%20horizontal%20layout%2C%20no%20text&width=600&height=450&seq=cards-05&orientation=landscape',
  },
  {
    id: 6,
    title: '高分纪录片推荐',
    desc: '拓展视野的优质纪录片，自然、人文、科技，每一部都让你收获满满。',
    tag: '精选',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20themed%20visual%20with%20earthy%20warm%20tones%20and%20natural%20textures%2C%20soft%20cinematic%20lighting%2C%20elegant%20abstract%20composition%2C%20editorial%20photography%20style%2C%20horizontal%20layout%2C%20no%20text&width=600&height=450&seq=cards-06&orientation=landscape',
  },
  {
    id: 7,
    title: '综艺大盘点',
    desc: '搞笑、竞技、旅行、美食，各类热门综艺一网打尽，承包你的闲暇时光。',
    tag: '综艺',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20entertainment%20visual%20with%20vibrant%20colorful%20stage%20lights%20in%20warm%20golden%20and%20coral%20tones%2C%20dynamic%20atmosphere%2C%20celebratory%20mood%2C%20editorial%20design%2C%20horizontal%20layout%2C%20no%20text&width=600&height=450&seq=cards-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            编辑精选，发现更多好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href={`#card-${item.id}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-4 md:mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.slice(4).map((item) => (
            <a
              key={item.id}
              href={`#card-${item.id}`}
              className="group flex bg-background-100 rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="w-28 md:w-36 flex-shrink-0 relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded inline-block w-fit mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}